export default __webpack_public_path__ + "static/media/hardware.4aa0b762.png";